import { privateRequest, type ApiResponse } from "../axios";
import { saveAsExcelFile } from "../excelService/excelSevice";

const ENDPOINTS = {
  SECONDARY_SALES_ORDER: "api/Distributor/Orders",
  SECONDARY_SALES_ITEM: "api/CRM/OrderDetail",
  EXPORT: "api/DistributorOrders/Export",
};

const getSecondarySaleList = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.SECONDARY_SALES_ORDER,
    { params: data },
  );
  return res.data;
};

const getSecondarySalesItemList = async (
  data: any,
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.SECONDARY_SALES_ITEM,
    { params: data },
  );
  return res.data;
};

const getSecondarySalesExport = async (
  data: any,
) => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.EXPORT,
    { params: data, responseType: "arraybuffer" },
  );
  return res;
};

const SecondarySalesOrder = {
  getSecondarySaleList,
  getSecondarySalesItemList,
  getSecondarySalesExport,
};

export default SecondarySalesOrder;
